import { useEffect, useState } from "react";
import { billingMicroserviceUrl } from "../../../../microservices/billing_microservice";
import { usersMicroserviceUrl } from "../../../../microservices/users_microservice";
import { LoadShortDate } from "../../../../functions/LoadShortDate";
import "../../../../styles/workspace_styles/TenantAdministratorStyles/BillingAccounts/BillingAccount.css";

const BillingAccount = ({
    user,
    logout,
    showCustomerBillingAccount,
    setShowCustomerBillingAccount,
    customerBillingAccountId
}) =>{
    const[userProfile,setUserProfile] = useState(null);
    const[customerBillingAccount,setCustomerBillingAccount] = useState(null);
    const[currencyExchangeRates,setCurrencyExchangeRates] = useState(null);
    const[showProfile,setShowProfile] = useState(false);
    const[showTransactions,setShowTransactions] = useState(false);
    const[showTopUp,setShowTopUp] = useState(false);
    const[showCurrencyExchangeRates,setShowCurrencyExchangeRates] = useState(false);
    const[showCashTopUp,setShowCashTopUp] = useState(false);
    const[showMPesaTopUp,setShowMPesaTopUp] = useState(false);
    const[showBankChequeTopUp,setShowBankChequeTopUp] = useState(false);
    const[filteredAndSortedTransactions,setFilteredAndSortedTransactions] = useState([]);
    const[transactionFilterType,setTransactionFilterType] = useState('ALL');
    const[transactionFilterPaymentMethodStatus,setTransactionFilterPaymentMethodStatus] = useState('ALL');
    const[transactionsSortMethod,setTransactionSortMethod] = useState('latest-first');
    const[cashTopUpAmount,setCashTopUpAmount] = useState('');
    const[cashTopUpCurrency,setCashTopUpCurrency] = useState('KES');
    const[cashTopUpOperation,setCashTopUpOperation] = useState('data-entry');
    const[mpesaTopUpMobileNumber,setMpesaTopUpMobileNumber] = useState('');
    const[mpesaTopUpAmount,setMpesaTopUpAmount] = useState('');
    const[mpesaTopUpOperation,setMpesaTopUpOperation] = useState('data-entry');
    const[mpesaTopUpTransactionFailureReason,setMpesaTopUpTransactionFailureReason] = useState(null);
    const[bankChequeTopUpBankName,setBankChequeTopUpBankName] = useState('');
    const[bankChequeTopUpChequeNumber,setBankChequeTopUpChequeNumber] = useState('');
    const[bankChequeTopUpBankCode,setBankChequeTopUpBankCode] = useState('');
    const[bankChequeTopUpAccountNumber,setBankChequeTopUpAccountNumber] = useState('');
    const[bankChequeTopUpAmount,setBankChequeTopUpAmount] = useState('');
    const[bankChequeTopUpCurrency,setBankChequeTopUpCurrency] = useState('KES');
    const[bankChequeTopUpOperation,setBankChequeTopUpOperation] = useState('data-entry');
    const fetchCustomerBillingAccount = async() =>{
        try{
            const url = `${billingMicroserviceUrl}/tenants/accounts/${customerBillingAccountId}`;
            const response = await fetch(url,{
                method:'GET',
                headers:{
                    'Authorization':`Bearer ${user.access_token}`
                }
            });
            if(response.ok){
                const responseData = await response.json();
                setCustomerBillingAccount(responseData);
            }
            else throw new Error(response.status);
        }
        catch(error){
            console.error(`Could not fetch user billing account id: ${customerBillingAccount}`,error);
        }
    };
    const fetchUserProfile = async() =>{
        try{
            const url = `${usersMicroserviceUrl}/tenants/customer-users/${customerBillingAccount.userId}`;
            const response = await fetch(url,{
                method:'GET',
                headers:{
                    'Authorization':`Bearer ${user.access_token}`,
                    'Content-Type':'application/json'
                }
            });
            if(response.ok){
                const responseData = await response.json();
                setUserProfile(responseData);
            }
            else throw new Error(`Error code: ${response.status}`)
        }
        catch(error){
            console.error('An error occurred when fetching user profile. ',error);
        }
    };
    const fetchLatestCurrencyExchangeRates = async() =>{
        try{
            const url = `${billingMicroserviceUrl}/tenants/currencies/exchange/rates/latest/get`;
            const response = await fetch(url,{
                method:'GET',
                headers:{
                    'Authorization':`Bearer ${user.access_token}`
                }
            });
            if(response.ok){
                const responseData = await response.json();
                setCurrencyExchangeRates(responseData);
            }
            else throw new Error(response.status);
        }
        catch(error){
            console.error('An error occurred when fetching the latest currencies',error);
        }
    };
    const topUpWithCash = async() =>{
        try{
            const url = `${billingMicroserviceUrl}/tenants/accounts/deposit/cash`;
            const cashDepositPayload = {
                accountId:customerBillingAccount.accountId,
                amount:cashTopUpAmount.replace(/,/g,''),
                currency:cashTopUpCurrency
            }
            const response = await fetch(url,{
                method:'POST',
                headers:{
                    'Authorization':`Bearer ${user.access_token}`,
                    'Content-Type':'application/json'
                },
                body: JSON.stringify(cashDepositPayload)
            });
            if(response.ok){
                await fetchCustomerBillingAccount();
                setCashTopUpOperation('top-up-success');
            }
            else throw new Error(response.status);
        }
        catch(error){
            console.error(`An error occurred when toping up account with id: ${customerBillingAccount? customerBillingAccount.accountId:null} using cash`,error);
            setCashTopUpOperation('top-up-failed');
        }
    }
    const topUpWithMpesa = async() =>{
        try{
            setMpesaTopUpTransactionFailureReason('');
            const url = `${billingMicroserviceUrl}/tenants/accounts/deposit/mpesa`;
            const mpesaSTKPushPayload = {
                accountId:customerBillingAccount.accountId,
                amount: Number(mpesaTopUpAmount.replace(/,/g,'')),
                phoneNumber: mpesaTopUpMobileNumber.replace(/^0(7|1)/,"254$1")
            };
            console.log('Payload',mpesaSTKPushPayload);
            const response = await fetch(url,{
                method:'POST',
                headers:{
                    'Authorization':`Bearer ${user.access_token}`,
                    'Content-Type':'application/json'
                },
                body: JSON.stringify(mpesaSTKPushPayload)
            });
            if(response.ok){
                const responseData = await response.json();
                const transactionDetails = responseData.type.split(':');
                if(transactionDetails.length > 2 && transactionDetails[0] == 'TOP UP' && transactionDetails[1] == 'MPESA'){
                    const transactionStatus = transactionDetails[2];
                    if(transactionStatus === 'COMPLETE'){
                        setMpesaTopUpOperation('top-up-success');
                    }
                    else if(transactionStatus === 'PENDING'){
                        setMpesaTopUpOperation('top-up-pending');
                    }
                    else if(transactionStatus === 'FAILED' && transactionDetails.length === 5){
                        setMpesaTopUpTransactionFailureReason(transactionDetails[4]);
                        setMpesaTopUpOperation('top-up-failed');
                    }
                    else setMpesaTopUpOperation('top-up-failed');
                }
                await fetchCustomerBillingAccount();
            }
            else throw new Error(response.status);
        }
        catch(error){
            console.error(`An error occurred when toping up account with id: ${customerBillingAccount? customerBillingAccount.accountId:null} using mpesa`,error);
            setMpesaTopUpOperation('top-up-failed');
        }
    };
    const topUpWithBankCheque = async() =>{
        try{
            const url = `${billingMicroserviceUrl}/tenants/accounts/deposit/bank/cheque`;
            const bankChequeDepositPayload = {
                accountId:customerBillingAccount.accountId,
                amount:bankChequeTopUpAmount.replace(/,/g,''),
                currency:bankChequeTopUpCurrency,
                bankName:bankChequeTopUpBankName,
                chequeNumber:bankChequeTopUpChequeNumber,
                bankCode:bankChequeTopUpBankCode,
                accountNumber:bankChequeTopUpAccountNumber
            };
            const response = await fetch(url,{
                method:'POST',
                headers:{
                    'Authorization':`Bearer ${user.access_token}`,
                    'Content-Type':'application/json'
                },
                body: JSON.stringify(bankChequeDepositPayload)
            });
            if(response.ok){
                await fetchCustomerBillingAccount();
                setBankChequeTopUpOperation('top-up-success');
            }
            else throw new Error(response.status);
        }
        catch(error){
            console.error(`An error occurred when topping up account with id: ${customerBillingAccount? customerBillingAccount.accountId:null} using a bank cheque`,error);
            setBankChequeTopUpOperation('top-up-failed');
        }
    }
    const filterAndSortTransactions = () =>{
        if(!customerBillingAccount || !customerBillingAccount.transactions) return;
        const filtered = customerBillingAccount.transactions.filter(transaction =>{
            const typeParts = transaction.type.split(":");
            const transactionType = typeParts[0]; //TOP UP or DEDUCTION
            const paymentMethod = typeParts[1] || "";//CASH, MPESA, BANK CHEQUE
            const mpesaStatus = typeParts[2] || "";//FAILED PENDING COMPLETE

            const matchesTransactionType = transactionFilterType === "ALL" || transactionFilterType === transactionType;
            const matchesPaymentMethod = 
                transactionFilterPaymentMethodStatus === "ALL" ||
                transactionFilterPaymentMethodStatus === paymentMethod ||
                transactionFilterPaymentMethodStatus === `${paymentMethod}:${mpesaStatus}`;
            return matchesTransactionType && (transactionFilterType !== "TOP UP" || matchesPaymentMethod);
        });
        const filteredAndSorted = filtered.sort((a,b) =>{
            const dateA = new Date(a.transactionDate + " " + a.transactionTime);
            const dateB = new Date(b.transactionDate + " " + b.transactionTime);
            return transactionsSortMethod === 'latest-first'? dateB - dateA:dateA -dateB;
        });
        setFilteredAndSortedTransactions(filteredAndSorted);
    };
    const clearBankChequeTopUpEntries = () =>{
        setBankChequeTopUpBankName('');
        setBankChequeTopUpChequeNumber('');
        setBankChequeTopUpBankCode('');
        setBankChequeTopUpAccountNumber('');
        setBankChequeTopUpAmount('');
        setBankChequeTopUpCurrency('KES');
    }
    useEffect(() =>{
        setShowTransactions(false);
        setShowTopUp(false);
        setShowCurrencyExchangeRates(false);
        setShowProfile(true);
        setShowCashTopUp(true);
        setShowMPesaTopUp(false);
        setShowBankChequeTopUp(false);
        if(customerBillingAccountId) fetchCustomerBillingAccount();
        fetchLatestCurrencyExchangeRates();
    },[showCustomerBillingAccount]);
    useEffect(() =>{
        if(customerBillingAccount){
            fetchUserProfile();
        }
    },[customerBillingAccount]);
    useEffect(() =>{
        filterAndSortTransactions();
    },[customerBillingAccount,transactionFilterType,transactionFilterPaymentMethodStatus,transactionsSortMethod]);
    useEffect(() => {
        if(!showMPesaTopUp){
            setMpesaTopUpMobileNumber('');
            setMpesaTopUpAmount('');
        }
    },[showMPesaTopUp]);
    if(!showCustomerBillingAccount) return null;
    return(
        <div className="customer-billing-account-container">
            <div className="customer-billing-account-header">
                <div>
                    <h3>{`${customerBillingAccount? userProfile?.emailAddress:'Loading...'}`}</h3>
                    <h4>Customer billing account details</h4>
                </div>
                <div>
                    <p onClick={() =>{
                        setCustomerBillingAccount(null);
                        setShowCustomerBillingAccount(false);
                    }}>&#10006;</p>
                </div>
            </div>
            <div className="customer-billing-account-navigation-bar">
                <button onClick={() =>{
                    setShowTransactions(false);
                    setShowTopUp(false);
                    setShowCurrencyExchangeRates(false);
                    setShowProfile(true);
                }}
                style={{
                    backgroundColor:`${showProfile? 'rgb(169,169,169)':'white'}`
                }}>Details</button>
                <button onClick={() =>{
                    setShowProfile(false);
                    setShowTopUp(false);
                    setShowCurrencyExchangeRates(false);
                    setShowTransactions(true);
                }}
                style={{
                    backgroundColor:`${showTransactions? 'rgb(169,169,169)':'white'}`
                }}>Transactions</button>
                <button onClick={() =>{
                    setShowProfile(false);
                    setShowTransactions(false);
                    setShowCurrencyExchangeRates(false);
                    setShowTopUp(true);
                }}
                style={{
                    backgroundColor:`${showTopUp? 'rgb(169,169,169)':'white'}`
                }}>Top up</button>
                <button onClick={() =>{
                    setShowProfile(false);
                    setShowTransactions(false);
                    setShowTopUp(false);
                    setShowCurrencyExchangeRates(true);
                }}
                style={{
                    backgroundColor:`${showCurrencyExchangeRates? 'rgb(169,169,169)':'white'}`
                }}>Exchange rates</button>
            </div>
            <div className="customer-billing-account-body">
                <div className="customer-billing-account-user-profile-container"
                    style={{display:`${showProfile? 'block':'none'}`}}>
                    <div className="customer-billing-account-user-profile-component">
                        <p>First name</p>
                        <input value={userProfile? userProfile.firstName:''} readOnly={true}/>
                    </div>
                    <div className="customer-billing-account-user-profile-component">
                        <p>Last name</p>
                        <input value={userProfile? userProfile.lastName:''} readOnly={true}/>
                    </div>
                    <div className="customer-billing-account-user-profile-component">
                        <p>Email address</p>
                        <input value={userProfile? userProfile.emailAddress:''} readOnly={true}/>
                    </div>
                    <div className="customer-billing-account-user-profile-component">
                        <p>Phone number</p>
                        <input value={userProfile? userProfile.phoneNumber:''} readOnly={true}/>
                    </div>
                    <div className="customer-billing-account-user-profile-component">
                        <p>Country</p>
                        <input value={userProfile? userProfile.country:''} readOnly={true}/>
                    </div>
                    <div className="customer-billing-account-user-profile-component">
                        <p>City</p>
                        <input value={userProfile? userProfile.city:''} readOnly={true}/>
                    </div>
                </div>
                <div className="customer-billing-account-transactions-container"
                    style={{display:`${showTransactions? 'block':'none'}`}}>
                    <div className="customer-billing-account-transactions-balance-container">
                        <p>Current balance</p>
                        <p className="customer-billing-account-transactions-balance-value-paragraph">
                            {customerBillingAccount && customerBillingAccount.balance !== undefined? 
                                `KES ${Number(customerBillingAccount.balance).toLocaleString('en-US',{minimumFractionDigits:2,maximumFractionDigits:2})}`:
                                'Unavailable'
                            }
                        </p>
                    </div>
                    <div className="customer-billing-account-transactions-entries-container">
                        <div>
                            <div>
                                <p>Transactions</p>
                            </div>
                            <div className="customer-billing-account-transactions-filter-bar"
                                style={{
                                    display:`${
                                        customerBillingAccount && customerBillingAccount.transactions && customerBillingAccount.transactions.length > 0?
                                        'block':'none'
                                    }`
                                }}>
                                <div>
                                    <button
                                        className={`${transactionFilterType === "ALL"? 'active':'inactive'}`}
                                        onClick={() => setTransactionFilterType("ALL")}>All</button>
                                    <button
                                        className={`${transactionFilterType === "TOP UP"? 'active':'inactive'}`}
                                        onClick={() => setTransactionFilterType("TOP UP")}>Top up</button>
                                    <button
                                        className={`${transactionFilterType === "DEDUCTION"? 'active':'inactive'}`}
                                        onClick={() => setTransactionFilterType("DEDUCTION")}>Deduction</button>
                                </div>
                                <div
                                    className="customer-billing-account-transactions-top-up-filter-bar"
                                    style={{display:`${transactionFilterType === 'TOP UP'? 'block':'none'}`}}>
                                    <button
                                        className={`${transactionFilterPaymentMethodStatus === 'ALL'? 'active':'inactive'}`}
                                        onClick={() => setTransactionFilterPaymentMethodStatus("ALL")}>All</button>
                                    <button
                                        className={`${transactionFilterPaymentMethodStatus === 'CASH'? 'active':'inactive'}`}
                                        onClick={() => setTransactionFilterPaymentMethodStatus("CASH")}>Cash</button>
                                    <button
                                        className={`${transactionFilterPaymentMethodStatus === 'MPESA:COMPLETE'? 'active':'inactive'}`}
                                        onClick={() => setTransactionFilterPaymentMethodStatus("MPESA:COMPLETE")}>M-Pesa Complete</button>
                                    <button
                                        className={`${transactionFilterPaymentMethodStatus === 'MPESA:PENDING'? 'active':'inactive'}`}
                                        onClick={() => setTransactionFilterPaymentMethodStatus("MPESA:PENDING")}>M-Pesa Pending</button>
                                    <button
                                        className={`${transactionFilterPaymentMethodStatus === 'MPESA:FAILED'? 'active':'inactive'}`}
                                        onClick={() => setTransactionFilterPaymentMethodStatus("MPESA:FAILED")}>M-Pesa Failed</button>
                                    <button
                                        className={`${transactionFilterPaymentMethodStatus === 'BANK_CHEQUE'? 'active':'inactive'}`}
                                        onClick={() => setTransactionFilterPaymentMethodStatus("BANK_CHEQUE")}>Bank Cheque</button>
                                </div>
                            </div>
                        </div>
                        <div
                            className="customer-billing-account-transactions-unavailable-container"
                            style={{
                                display:`${
                                    !customerBillingAccount || !customerBillingAccount.transactions || !customerBillingAccount.transactions.length > 0?
                                    'block':'none'
                                }`}}>
                            <p>No transactions have been performed for this account yet.</p>
                        </div>
                        <div
                            style={{
                                display:`${
                                    customerBillingAccount && customerBillingAccount.transactions && customerBillingAccount.transactions.length > 0?
                                    'block':'none'
                                }`
                            }}
                            className="customer-billing-account-transactions-table-container">
                            <div className="customer-billing-account-transactions-table-sort-icon-container"
                                onClick={() => setTransactionSortMethod(`${transactionsSortMethod === 'latest-first'? 'earliest-first':'latest-first'}`)}
                                title={`${transactionsSortMethod === 'latest-first'? 'Sorted by latest to earliest, click to reverse':'Sorted by earliest to latest, click to reverse'}`}>
                                <img src={`${process.env.PUBLIC_URL}/images/sort-icon.png`}/>
                            </div>
                            <table>
                                <thead>
                                    <tr className="customer-billing-account-transaction-table-header-row">
                                        <th>Type</th>
                                        <th>Amount</th>
                                        <th>Date</th>
                                        <th>Time</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {filteredAndSortedTransactions && filteredAndSortedTransactions.map(transaction => (
                                        <tr key={transaction.id}>
                                            <td>{transaction.type}</td>
                                            <td>KES {Number(transaction.amount).toLocaleString('en-US',{minimumFractionDigits:2,maximumFractionDigits:2})}</td>
                                            <td>{LoadShortDate(transaction.transactionDate)}</td>
                                            <td>{transaction.transactionTime.split('.')[0]}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <div className="customer-billing-account-top-up-container"
                    style={{display:`${showTopUp? 'block':'none'}`}}>
                    <div className="customer-billing-account-top-up-navigation-bar">
                        <button onClick={() =>{
                            setShowMPesaTopUp(false);
                            setShowBankChequeTopUp(false);
                            setShowCashTopUp(true);
                        }}>Cash</button>
                        <button onClick={() =>{
                            setShowCashTopUp(false);
                            setShowBankChequeTopUp(false);
                            setShowMPesaTopUp(true);
                        }}>M-Pesa</button>
                        <button onClick={() =>{
                            setShowCashTopUp(false);
                            setShowMPesaTopUp(false);
                            setShowBankChequeTopUp(true);
                        }}>Bank Cheque</button>
                    </div>
                    <div>
                        <div
                            className="customer-billing-account-cash-top-up-container"
                            style={{display:`${showCashTopUp? 'block':'none'}`}}>
                            <div className="customer-billing-account-cash-top-up-entry-container"
                                style={{display:`${cashTopUpOperation === 'data-entry'? 'block':'none'}`}}>
                                <div>
                                    <p>Cash deposit</p>
                                </div>
                                <div className="customer-billing-account-cash-top-up-entry-amount-container">
                                    <div>
                                        <p>Amount</p>
                                    </div>
                                    <div>
                                        <input
                                            type="text"
                                            placeholder="Enter amount to top up"
                                            value={cashTopUpAmount}
                                            onChange={(e) => {
                                                const value = e.target.value.replace(/,/g, '');
                                                if(/^\d*\.?\d{0,2}$/.test(value)) setCashTopUpAmount(value);
                                            }}
                                            onFocus={(e) =>{
                                                setCashTopUpAmount(String(cashTopUpAmount).replace(/,/g,''));
                                            }}
                                            onBlur={(e) =>{
                                                if(cashTopUpAmount !== ''){
                                                    setCashTopUpAmount(Number(cashTopUpAmount).toLocaleString('en-US',{
                                                        minimumFractionDigits:2,
                                                        maximumFractionDigits:2
                                                    }));
                                                }
                                            }}
                                        />
                                    </div>
                                </div>
                                <div className="customer-billing-account-cash-top-up-entry-currency-container">
                                    <div>
                                        <p>Currency</p>
                                    </div>
                                    <div>
                                        <select value={cashTopUpCurrency? cashTopUpCurrency:'KES'} onChange={(e) => {
                                            if(e === null || e.target === null || e.target.value === null) return;
                                            setCashTopUpCurrency(e.target.value)
                                        }}>
                                            {currencyExchangeRates.rates != null && Object.entries(currencyExchangeRates.rates)
                                            .sort(([isoA],[isoB]) =>{
                                                if(isoA === 'KES') return -1;
                                                if(isoB === 'KES') return 1;
                                                if(isoA === 'USD' && isoB !== 'KES') return -1;
                                                if(isoB === 'USD' && isoA !== 'KES') return 1;
                                                return isoA.localeCompare(isoB);
                                            }).map(([isoCode]) =>(
                                                <option key={isoCode} value={isoCode}>{`${currencyExchangeRates.currencies[isoCode]}\t(${isoCode})`}</option>
                                            ))}
                                        </select>
                                    </div>
                                </div>
                                <div className="customer-billing-account-cash-top-up-entry-deposit-button-container">
                                    <button onClick={async() => {
                                        if(cashTopUpAmount === ''){
                                            window.alert('Please enter the top up amount to proceed');
                                            return;
                                        }
                                        setCashTopUpOperation('topping-up');
                                        await topUpWithCash();
                                    }}>
                                        Deposit
                                    </button>
                                </div>
                            </div>
                            <div className="customer-billing-account-cash-topping-up-container"
                                style={{display:`${cashTopUpOperation === 'topping-up'? 'block' :'none'}`}}>
                                    <div>
                                        <div className="spinner"></div>
                                    </div>
                                    <div>
                                        <p>Topping up account with cash</p>
                                    </div>
                            </div>
                            <div className="customer-billing-account-cash-top-up-success-container"
                                style={{display:`${cashTopUpOperation === 'top-up-success'? 'block':'none'}`}}>
                                <div>
                                    <p className="header-paragraph">Success</p>
                                    <p>{cashTopUpCurrency} {cashTopUpAmount} deposited successfully</p>
                                </div>
                                <div>
                                    <button onClick={()=>{
                                        setCashTopUpAmount('');
                                        setCashTopUpOperation('data-entry');
                                        setShowTopUp(false);
                                        setShowTransactions(true);
                                    }}>View transactions</button>
                                    <button onClick={() =>{
                                        setCashTopUpAmount('');
                                        setCashTopUpOperation('data-entry');
                                    }}>Top up more</button>
                                </div>
                            </div>
                            <div className="customer-billing-account-cash-top-up-failed-container"
                                style={{display:`${cashTopUpOperation === 'top-up-failed'? 'block':'none'}`}}>
                                <div>
                                    <p className="header-paragraph">Top up failed</p>
                                    <p>Cash deposit of {cashTopUpCurrency} {cashTopUpAmount} failed</p>
                                </div>
                                <div>
                                    <button onClick={() =>{
                                        setCashTopUpAmount('');
                                        setCashTopUpOperation('data-entry');
                                    }}>Okay</button>
                                </div>
                            </div>
                        </div>
                        <div
                            className="customer-billing-account-mpesa-top-up-container"
                            style={{display:`${showMPesaTopUp? 'block':'none'}`}}>
                            <div className="customer-billing-account-mpesa-top-up-entry-container"
                                style={{display:`${mpesaTopUpOperation === 'data-entry'? 'block':'none'}`}}>
                                <div className="customer-billing-account-mpesa-top-up-entry-title-container">
                                    <p title="Trigger an M-Pesa prompt on the customer's phone for quick payment">M-Pesa STK push</p>
                                </div>
                                <div className="customer-billing-account-mpesa-top-up-entry-mobile-number-container">
                                    <p>Mobile number</p>
                                    <input
                                        type="text"
                                        placeholder="Enter M-Pesa mobile number (07XXX...)"
                                        value={mpesaTopUpMobileNumber}
                                        onChange={(e) => {
                                            let value = e.target.value;
                                            if(value === "" || /^\d{0,10}$/.test(value)) setMpesaTopUpMobileNumber(value);
                                        }}
                                    />
                                    <label style={{
                                        display:`${
                                            mpesaTopUpMobileNumber === '' || /^07\d{8}$/.test(mpesaTopUpMobileNumber)? 'none':'block'
                                        }`
                                    }}>Invalid phone number</label>
                                </div>
                                <div className="customer-billing-account-mpesa-top-up-entry-amount-container">
                                    <p>Amount</p>
                                    <input
                                        type="text"
                                        placeholder="Enter amount in KES"
                                        value={mpesaTopUpAmount}
                                        onChange={(e) =>{
                                            const value = e.target.value.replace(/,/g,'');
                                            if(/^\d+$/.test(value) || value === '') setMpesaTopUpAmount(e.target.value);
                                        }}
                                        onFocus={(e) => {
                                            setMpesaTopUpAmount(String(mpesaTopUpAmount).replace(/,/g,''));
                                        }}
                                        onBlur={(e) => {
                                            if(mpesaTopUpAmount !== ''){
                                                setMpesaTopUpAmount(Number(mpesaTopUpAmount).toLocaleString('en-US',{
                                                    minimumFractionDigits:0,maximumFractionDigits:0
                                                }))
                                            }
                                        }}/>
                                </div>
                                <div className="customer-billing-account-mpesa-top-up-entry-stk-push-button-container">
                                    <button onClick={async() =>{
                                        if(mpesaTopUpMobileNumber === ''){
                                            window.alert('Please enter the mobile number to push STK to');
                                            return;
                                        }
                                        else if(!/^07\d{8}$/.test(mpesaTopUpMobileNumber)){
                                            window.alert('Invalid mobile number. Please correct the mobile number to proceed');
                                        }
                                        else if(mpesaTopUpAmount === ''){
                                            window.alert('Please enter the top up amount to proceed');
                                            return;
                                        }
                                        setMpesaTopUpOperation('topping-up');
                                        await topUpWithMpesa();
                                    }}>Push STK</button>
                                </div>
                            </div>
                            <div className="customer-billing-account-mpesa-topping-up-container"
                                style={{display:`${mpesaTopUpOperation === 'topping-up' ? 'block':'none'}`}}>
                                    <div>
                                        <div className="spinner"></div>
                                    </div>
                                    <div>
                                        <p>Topping up the customer's account via M-Pesa. Please ensure the customer approves the STK push on their phone and wait for confirmation.</p>
                                    </div>
                            </div>
                            <div className="customer-billing-account-mpesa-top-up-success-container"
                                style={{display:`${mpesaTopUpOperation === 'top-up-success'? 'block':'none'}`}}>
                                <div>
                                    <p className="header-paragraph">Success</p>
                                    <p>KES {mpesaTopUpAmount} topped up successfully via Mpesa</p>
                                </div>
                                <div>
                                    <button onClick={() =>{
                                        setMpesaTopUpMobileNumber('');
                                        setMpesaTopUpAmount('');
                                        setMpesaTopUpOperation('data-entry');
                                        setShowTopUp(false);
                                        setShowTransactions(true);
                                    }}>View transactions</button>
                                    <button onClick={() =>{
                                        setMpesaTopUpMobileNumber('');
                                        setMpesaTopUpAmount('');
                                        setMpesaTopUpOperation('data-entry');
                                    }}>Top up more</button>
                                </div>
                            </div>
                            <div className="customer-billing-account-mpesa-top-up-pending-container"
                                style={{display:`${mpesaTopUpOperation === 'top-up-pending'? 'block':'none'}`}}>
                                <div>
                                    <p className="header-paragraph">Transaction pending</p>
                                    <div className="pending-body-container">
                                        <p>The top up request of KES {mpesaTopUpAmount? mpesaTopUpAmount:'*'} via Mpesa could not be completed.</p>
                                        <p>Please check the transaction later</p>
                                    </div>
                                </div>
                                <div>
                                    <button onClick={() =>{
                                        setMpesaTopUpMobileNumber('');
                                        setMpesaTopUpAmount('');
                                        setMpesaTopUpOperation('data-entry');
                                        setShowTopUp(false);
                                        setShowTransactions(true);
                                    }}>View transactions</button>
                                    <button onClick={() =>{
                                        setMpesaTopUpAmount('');
                                        setMpesaTopUpOperation('data-entry');
                                    }}>Try another top up</button>
                                </div>
                            </div>
                            <div className="customer-billing-account-mpesa-top-up-failed-container"
                                style={{display:`${mpesaTopUpOperation === 'top-up-failed'? 'block':'none'}`}}>
                                <div>
                                    <p className="header-paragraph">Top up failed</p>
                                    <div className="failure-body-container">
                                        <p>Top up of KES {mpesaTopUpAmount? mpesaTopUpAmount:'0'} via Mpesa failed</p>
                                        <p>{mpesaTopUpTransactionFailureReason? mpesaTopUpTransactionFailureReason:'Unable to send request to server'}</p>
                                    </div>
                                </div>
                                <div>
                                    <button onClick={() =>{
                                        setMpesaTopUpMobileNumber('');
                                        setMpesaTopUpAmount('');
                                        setMpesaTopUpOperation('data-entry');
                                        setShowTopUp(false);
                                        setShowTransactions(true);
                                    }}>View transactions</button>
                                    <button onClick={() =>{
                                        setMpesaTopUpAmount('');
                                        setMpesaTopUpOperation('data-entry');
                                    }}>Try again</button>
                                </div>
                            </div>
                        </div>
                        <div
                            className="customer-billing-account-bank-cheque-top-up-container"
                            style={{display:`${showBankChequeTopUp? 'block':'none'}`}}>
                                <div className="customer-billing-account-bank-cheque-top-up-entry-container"
                                    style={{display:`${bankChequeTopUpOperation === 'data-entry'? 'block':'none'}`}}>
                                    <div>
                                        <p>Bank Cheque top up</p>
                                    </div>
                                    <div className="customer-billing-account-bank-cheque-top-up-entry-bank-name-container">
                                        <div>
                                            <p>Bank Name</p>
                                        </div>
                                        <div>
                                            <input
                                                type="text"
                                                placeholder="Enter bank name"
                                                value={bankChequeTopUpBankName}
                                                onChange={(e)=> setBankChequeTopUpBankName(e.target.value)}
                                            />
                                        </div>
                                    </div>
                                    <div className="customer-billing-account-bank-cheque-top-up-entry-cheque-number-container">
                                        <div>
                                            <p>Cheque Number</p>
                                        </div>
                                        <div>
                                            <input
                                                type="text"
                                                placeholder="Enter cheque number"
                                                value={bankChequeTopUpChequeNumber}
                                                onChange={(e) => setBankChequeTopUpChequeNumber(e.target.value)}
                                            />
                                        </div>
                                    </div>
                                    <div className="customer-billing-account-bank-cheque-top-up-entry-bank-code-container">
                                        <div>
                                            <p>Bank Code</p>
                                        </div>
                                        <div>
                                            <input
                                                type="text"
                                                placeholder="Enter bank code"
                                                value={bankChequeTopUpBankCode}
                                                onChange={(e) => setBankChequeTopUpBankCode(e.target.value)}
                                            />
                                        </div>
                                    </div>
                                    <div className="customer-billing-account-bank-cheque-top-up-entry-account-number-container">
                                        <div>
                                            <p>Account Number</p>
                                        </div>
                                        <div>
                                            <input
                                                type="text"
                                                placeholder="Enter account number"
                                                value={bankChequeTopUpAccountNumber}
                                                onChange={(e) =>{
                                                    const value = e.target.value;
                                                    if(/^\d*$/.test(value)) setBankChequeTopUpAccountNumber(value);
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div className="customer-billing-account-bank-cheque-top-up-entry-amount-container">
                                        <p>Amount</p>
                                        <input
                                            type="text"
                                            placeholder="Enter amount to top up"
                                            value={bankChequeTopUpAmount}
                                            onChange={(e) =>{
                                                const value = e.target.value.replace(/,/g,'');
                                                if(/^\d*\.?\d{0,2}$/.test(value)) setBankChequeTopUpAmount(value);
                                            }}
                                            onFocus={(e) =>{
                                                setBankChequeTopUpAmount(String(bankChequeTopUpAmount).replace(/,/g,''));
                                            }}
                                            onBlur={(e) =>{
                                                if(bankChequeTopUpAmount !== ''){
                                                    setBankChequeTopUpAmount(Number(bankChequeTopUpAmount).toLocaleString('en-US',{
                                                        minimumFractionDigits:2,
                                                        maximumFractionDigits:2
                                                    }))
                                                }
                                            }}/>
                                    </div>
                                    <div className="customer-billing-account-bank-cheque-top-up-entry-currency-container">
                                        <div>
                                            <p>Currency</p>
                                        </div>
                                        <div>
                                            <select value={bankChequeTopUpCurrency} onChange={(e) => setBankChequeTopUpCurrency(e.target.value)}>
                                                {currencyExchangeRates !== null && currencyExchangeRates.rates && Object.entries(currencyExchangeRates.rates)
                                                .sort(([isoA],[isoB]) =>{
                                                    if(isoA === 'KES') return -1;
                                                    if(isoB === 'KES') return 1;
                                                    if(isoA === 'USD' && isoB !== 'KES') return -1;
                                                    if(isoB === 'USD' && isoA !== 'KES') return 1;
                                                    return isoA.localeCompare(isoB);
                                                }).map(([isoCode]) => (
                                                    <option key={isoCode} value={isoCode}>{`${currencyExchangeRates.currencies[isoCode]}\t(${isoCode})`}</option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>
                                    <div className="customer-billing-account-bank-cheque-top-up-entry-deposit-button-container">
                                        <button onClick={async() =>{
                                            if(bankChequeTopUpBankName === ''){
                                                window.alert('Please enter bank name to proceed');
                                                return;
                                            }
                                            if(bankChequeTopUpChequeNumber === ''){
                                                window.alert('Please enter cheque number to proceed');
                                                return;
                                            }
                                            if(bankChequeTopUpBankCode === ''){
                                                window.alert('Please enter bank code to proceed');
                                                return;
                                            }
                                            if(bankChequeTopUpAccountNumber === ''){
                                                window.alert('Please enter account number on the cheque to proceed');
                                                return;
                                            }
                                            if(bankChequeTopUpAmount === ''){
                                                window.alert('Please enter the amount on the cheque to proceed');
                                                return;
                                            }
                                            setBankChequeTopUpOperation('topping-up');
                                            await topUpWithBankCheque();
                                        }}>Deposit</button>
                                    </div>
                                </div>
                                <div className="customer-billing-account-bank-cheque-topping-up-container"
                                    style={{display:`${bankChequeTopUpOperation === 'topping-up'? 'block':'none'}`}}>
                                    <div>
                                        <div className="spinner"></div>
                                    </div>
                                    <div>
                                        <p>Topping up account with bank cheque...</p>
                                    </div>
                                </div>
                                <div className="customer-billing-account-bank-cheque-top-up-success-container"
                                    style={{display:`${bankChequeTopUpOperation === 'top-up-success'? 'block':'none'}`}}>
                                    <div>
                                        <p className="header-paragraph">Success</p>
                                        <p>{bankChequeTopUpCurrency} {bankChequeTopUpAmount} deposited successfully</p>
                                    </div>
                                    <div>
                                        <button onClick={() =>{
                                            clearBankChequeTopUpEntries();
                                            setBankChequeTopUpOperation('data-entry');
                                            setShowTopUp(false);
                                            setShowTransactions(true);
                                        }}>View transactions</button>
                                        <button onClick={() =>{
                                            clearBankChequeTopUpEntries();
                                            setBankChequeTopUpOperation('data-entry');
                                        }}>Deposit another cheque</button>
                                    </div>
                                </div>
                                <div className="customer-billing-account-bank-cheque-top-up-failed-container"
                                    style={{display:`${bankChequeTopUpOperation === 'top-up-failed'? 'block':'none'}`}}>
                                    <div>
                                        <p className="header-paragraph">Top up failed</p>
                                        <p>Deposit of {bankChequeTopUpCurrency} {bankChequeTopUpAmount} bank cheque failed</p>
                                    </div>
                                    <div>
                                        <button onClick={() =>{
                                            clearBankChequeTopUpEntries();
                                            setBankChequeTopUpOperation('data-entry');
                                        }}>Okay</button>
                                    </div>
                                </div>
                        </div>
                    </div>
                </div>
                <div className="customer-billing-account-currency-exchange-rates-container"
                    style={{display:`${showCurrencyExchangeRates? 'block':'none'}`}}>
                    {currencyExchangeRates? 
                        <div>
                            <div className="customer-billing-account-currency-exchange-rates-date-container">
                                <p>Updated on</p>
                                <p>{LoadShortDate(currencyExchangeRates.date)}</p>
                            </div>
                            <div className="customer-billing-account-currency-exchange-rates-time-container">
                                <p>Updated at</p>
                                <p>{currencyExchangeRates.time.split('.'[0])}</p>
                            </div>
                            <div className="customer-billing-account-currency-exchange-rates-table-container">
                                <table>
                                    <thead>
                                        <tr className="customer-billing-account-currency-exchange-rates-table-header-row">
                                            <th>ISO Code</th>
                                            <th>Currency</th>
                                            <th title="Multiply your value by rate to get value in KES">Rate</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {Object.entries(currencyExchangeRates.rates).map(([isoCode,rate]) =>(
                                            <tr key={isoCode}>
                                                <td>{isoCode}</td>
                                                <td>{currencyExchangeRates.currencies[isoCode]}</td>
                                                <td>{rate}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>:
                        <div>
                            <p>The latest currency exchange rates could not be loaded. Please try again later.</p>
                        </div>
                    }
                </div>
            </div>
        </div>
    );
};
export default BillingAccount;